// eslint-disable-next-line no-undef
module.exports = {
  green400: '#8cbb23',

  gray100: '#b8b8b8',

  dustyBlue500: '#2BA6CB',

  white: '#ffffff',
};
